import { render } from "./Pj.vue?vue&type=template&id=0e0bcb76&scoped=true"
import script from "./Pj.vue?vue&type=script&lang=js"
export * from "./Pj.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0bcb76"]])

export default __exports__